// Services & Industries are edited in the admin area and served by /api/services and
// /api/industries. These static copies (from content.js) are shown while the API loads
// and whenever it cannot be reached, so the public pages never render empty.
import { SERVICE_GROUPS, INDUSTRY_PAGE } from "./content";
import { HELP_OPTIONS } from "./site";

export const FALLBACK_SERVICES = SERVICE_GROUPS.flatMap((g) =>
  g.services.map(({ n, ...s }) => ({ ...s, id: s.slug, group: g.title })),
).map((s, i) => ({ ...s, order: i, published: true }));

export const FALLBACK_INDUSTRIES = [
  ...INDUSTRY_PAGE.coverage.groups.flatMap((g) =>
    g.items.map((name) => ({ name, section: "coverage", group: g.title })),
  ),
  ...INDUSTRY_PAGE.emerging.items.map((name) => ({ name, section: "emerging", group: INDUSTRY_PAGE.emerging.title })),
].map((x, i) => ({ ...x, id: `static-${i}`, order: i, published: true }));

const keyOf = (text) => (text || "other").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") || "other";

/** Group items by `group`, in order of first appearance. */
export const groupBy = (list, field = "group") => {
  const groups = [];
  const index = new Map();
  list.forEach((item) => {
    const title = item[field] || "";
    if (!index.has(title)) {
      index.set(title, groups.length);
      groups.push({ key: keyOf(title), title, items: [] });
    }
    groups[index.get(title)].items.push(item);
  });
  return groups;
};

/** Services grouped as on the Services page, numbered 01, 02 … in display order. */
export const groupServices = (services) => {
  let i = 0;
  return groupBy(services).map((g) => ({
    ...g,
    items: g.items.map((s) => ({ ...s, n: String(++i).padStart(2, "0") })),
  }));
};

export const numberedServices = (services) => groupServices(services).flatMap((g) => g.items);

/** Contact form "Area of interest" options: the original order (HELP_OPTIONS) for the existing
 * services, then any service added in the admin area, then "Other". */
export const contactAreas = (services) => {
  const areas = [];
  services.forEach((s) => {
    const area = s.area || s.title;
    if (area && !areas.includes(area)) areas.push(area);
  });
  const known = HELP_OPTIONS.filter((o) => o !== "Other" && areas.includes(o));
  const added = areas.filter((a) => !HELP_OPTIONS.includes(a));
  return [...known, ...added, "Other"];
};
